import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import ax from "../config"
import { openNotification } from "src/components/helpers/notification"
import { message } from "antd"

const initialState = {
  clientsList: null,
  clientsListLoading: false,
  addClientModal: false,
  addAbonementModal: false,
  abonementsList: null,
  getAbonementsClientList: null,
  getAbonementsClientListLoading: false,
  getClientTrainingsList: null,
  getClientTrainingsListLoading: false,
  getClientLinkList: null,
  getClientLinkListLoading: false,
  getClientTransactionsList: null,
  getClientTransactionsListLoading: false,
  getClientPersonalPacketList: null,
  getClientPersonalPacketListLoading: false,
  getClientStatusList: null,
  getClientStatusListLoading: false,
  clientLeadedTrainings: null,
  clientLeadedTrainingsLoading: false,
  changePassword: null,
  changePasswordLoading: false,
  getStatusesLoading: false,
  blockClientLoading: false,
  blockClient: null,
  getStatuses: null,
  clubs: null,
  abonements: null,
  userInfo: null,
  commentsList: null,
  commentsListLoading: null,
  reportData: null,
  code: null,
  packetsList: null,
  paymentSystems: null,
}

export const getClientsList = createAsyncThunk(
  "clients/client",
  async (payload, { dispatch }) => {
    try {
      payload.managerId = payload.manager
      console.log(payload)
      dispatch(setClientsListLoading(true))
      const { data } = await ax.get("/api/admin/clients/getClients", {
        params: payload,
        paramsSerializer: { indexes: null }, //for query params "true" = 'a[0]=b&a[1]=c'    "false" = 'a[]=b&a[]=c' - deffault   null = 'a=b&a=c'
      })
      data && dispatch(setClientsListLoading(false))
      return data
    } catch (error) {
      error && dispatch(setClientsListLoading(false))
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  },
)

export const addClent = createAsyncThunk("clients/addClient", async (payload) => {
  try {
    const { data } = await ax.put("/api/admin/clients/clientAdd", payload)
    openNotification({
      type: "success",
      message: `Клиент успешно добавлен`,
    })
    return data
  } catch (error) {
    openNotification({
      type: "error",
      message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
    })
  }
})

export const getUserInfo = createAsyncThunk("getUserInfo", async (payload) => {
  try {
    const { data } = await ax.get("/api/admin/clients/clientInfo", {
      params: payload,
    })
    return data
  } catch (error) {}
})

export const freezePayment = createAsyncThunk(
  "freezePayment",
  async (payload, { dispatch }) => {
    dispatch(setGetClientLinkListLoading(true))
    try {
      let data
      payload.method === "VTB(ТЕСТ)"
        ? ({ data } = await ax.post(
            "/api/recurrentVtb/createFreezePayment",
            payload.value,
          ))
        : ({ data } = await ax.post(
            "/api/recurrent/freezePaymentLink",
            payload.value,
          ))
      ;(data &&
        openNotification({
          type: "success",
          message: `Ссылка успешно добавлена`,
        }),
        dispatch(setGetClientLinkListLoading(false)))
      return data
    } catch (error) {
      dispatch(setGetClientLinkListLoading(false))
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
      return error
    }
  },
)

export const postAgreement = createAsyncThunk(
  "postAgreement",
  async (payload) => {
    try {
      const { data } = await ax.put(
        "/api/admin/clients/uploadAgreement",
        payload,
      )
      openNotification({
        type: "success",
        message: `Соглашение внесено успешно`,
      })
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  },
)

export const getAgreement = createAsyncThunk(
  "getAgreement",
  async (payload) => {
    try {
      const { data } = await ax.get("/api/admin/clients/getAgreement", {
        params: payload.value,
        responseType: "blob",
      })
      openNotification({
        type: "success",
        message: `Ответ получен`,
      })
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  },
)

export const editClent = createAsyncThunk("editClent", async (payload) => {
  try {
    const { data } = await ax.post("/api/admin/clients/editClientInfo", payload)
    openNotification({
      type: "success",
      message: `Клиент успешно отредактирован`,
    })
    return data
  } catch (error) {
    openNotification({
      type: "error",
      message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
    })
  }
})

export const getAbonementsList = createAsyncThunk(
  "getAbonements",
  async (payload) => {
    try {
      const { data } = await ax.get("/api/admin/abonementsClubs", {
        params: payload,
      })
      return data
    } catch (error) {}
  },
)

export const addAbonement = createAsyncThunk(
  "addAbonement",
  async (payload) => {
    try {
      const { data } = await ax.put(
        "/api/admin/clients/clientAbonementAdd",
        payload,
      )
      openNotification({
        type: "success",
        message: `Абонемент успешно добавлен`,
      })
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  },
)

export const addOneDayAbonement = createAsyncThunk(
  "addAbonement",
  async (payload) => {
    try {
      const { data } = await ax.put(
        "api/admin/clients/oneDayAbonement",
        payload,
      )
      openNotification({
        type: "success",
        message: `Абонемент успешно добавлен`,
      })
      return data
    } catch (error) {
      let message = "Неизвестная ошибка"

      if (
        error?.response?.data?.errorMessages &&
        Array.isArray(error.response.data.errorMessages) &&
        error.response.data.errorMessages[0]?.errorMessage
      ) {
        message = error.response.data.errorMessages[0].errorMessage
      } else if (error?.message) {
        message = error.message
      }

      openNotification({
        type: "error",
        message: `${message}`,
      })

      throw error
    }
  },
)

export const editAbonement = createAsyncThunk(
  "editAbonement",
  async (payload) => {
    try {
      const { data } = await ax.post(
        "/api/admin/clients/clientAbonementEdit",
        payload,
      )
      openNotification({
        type: "success",
        message: `Абонемент успешно отредактирован`,
      })
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  },
)

export const getAbonementsClient = createAsyncThunk(
  "clients/getAbonementsClient",
  async (payload, { dispatch }) => {
    try {
      dispatch(setGetAbonementsClientListLoading(true))
      const { data } = await ax.get("/api/admin/clients/clientAbonements", {
        params: payload,
      })
      data && dispatch(setGetAbonementsClientListLoading(false))
      return data
    } catch (error) {
      dispatch(setGetAbonementsClientListLoading(false))

      openNotification({
        type: "error",
        message: `${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  },
)

export const postRestoreClientAbonementThunk = createAsyncThunk(
  "clients/postRestoreClientAbonementThunk",
  async (payload, { dispatch }) => {
    try {
      const { data } = await ax.post(
        `/api/admin/clients/restoreClientAbonement?userAbonementId=${payload.userAbonementId}`,
      )
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  },
)

export const getClientLeadedTrainings = createAsyncThunk(
  "clients/getClientLeadedTrainings",
  async (payload, { dispatch }) => {
    try {
      dispatch(setClientLeadedTrainingsLoading(true))
      const { data } = await ax.get("/api/admin/clients/clientLeadedTrainings", {
        params: payload,
      })
      data && dispatch(setClientLeadedTrainingsLoading(false))
      return data
    } catch (error) {
      dispatch(setClientLeadedTrainingsLoading(false))
      openNotification({
        type: "error",
        message: `${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  },
)

export const assignLeadedTrainingTrainer = createAsyncThunk(
  "clients/assignLeadedTrainingTrainer",
  async (payload) => {
    try {
      const { data } = await ax.post(
        "/api/admin/clients/assignLeadedTrainingTrainer",
        payload,
      )
      openNotification({
        type: "success",
        message: payload.trainerId ? "Тренер назначен" : "Тренер снят",
      })
      return data ?? true
    } catch (error) {
      openNotification({
        type: "error",
        message: `${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  },
)

export const getClientTrainings = createAsyncThunk(
  "clients/getClientTrainings",
  async (payload, { dispatch }) => {
    try {
      dispatch(setGetClientTrainingsListLoading(true))
      const { data } = await ax.get("/api/admin/clients/clientTrainings", {
        params: payload,
      })
      data && dispatch(setGetClientTrainingsListLoading(false))
      return data
    } catch (error) {
      dispatch(setGetClientTrainingsListLoading(false))

      openNotification({
        type: "error",
        message: `${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  },
)

export const getReport = createAsyncThunk(
  "getReport",
  async (payload, { dispatch }) => {
    try {
      const { data } = await ax.post("/api/report/ShowReportBase64", payload)
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  },
)

export const frostClientAbonement = createAsyncThunk(
  "frostClientAbonement",
  async (payload, { dispatch }) => {
    try {
      const { data } = await ax.post(
        "/api/admin/clients/frostClientAbonement",
        payload,
      )
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  },
)

export const deleteClientAbonement = createAsyncThunk(
  "deleteClientAbonement",
  async (payload, { dispatch }) => {
    try {
      const { data } = await ax.post(
        "/api/admin/clients/deleteClientAbonement",
        payload,
      )
      data &&
        openNotification({
          type: "success",
          message: `Абонемент успешно удален`,
        })
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  },
)

export const cancelClientSubscription = createAsyncThunk(
  "cancelClientSubscription",
  async (payload, { dispatch }) => {
    try {
      const { data } = await ax.post(
        "/api/admin/clients/cancelClientSubscription",
        payload,
      )
      data &&
        openNotification({
          type: "success",
          message: `Подписка успешно отменена`,
        })
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `${error.response.data.errorMessages[0].errorMessage}`,
      })
      return error
    }
  },
)

export const editTraining = createAsyncThunk(
  "editTraining",
  async (payload, { dispatch }) => {
    try {
      const { data } = await ax.post(
        "/api/admin/clients/editClientTraining",
        payload,
      )
      data &&
        openNotification({
          type: "success",
          message: `Тренировка отредактирована успешно`,
        })
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  },
)

export const getClubs = createAsyncThunk(
  "getClubs",
  async (payload, { dispatch }) => {
    try {
      const { data } = await ax.get("/api/admin/getClubs")
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  },
)

export const getAbonements = createAsyncThunk(
  "abonements",
  async (payload, { dispatch }) => {
    try {
      const { data } = await ax.get("/api/admin/abonements")
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  },
)

export const getTransactions = createAsyncThunk(
  "getTransactions",
  async (payload, { dispatch }) => {
    try {
      dispatch(setGetClientTransactionsListLoading(true))
      const { data } = await ax.get("/api/admin/clients/transactions", {
        params: payload,
      })
      data && dispatch(setGetClientTransactionsListLoading(false))
      return data
    } catch (error) {
      dispatch(setGetClientTransactionsListLoading(false))
      openNotification({
        type: "error",
        message: `${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  },
)

export const getCode = createAsyncThunk("code", async (payload) => {
  try {
    const { data } = await ax.get("/api/admin/clients/code", {
      params: payload,
    })
    return data
  } catch (error) {
    openNotification({
      type: "error",
      message: `${error.response.data.errorMessages[0].errorMessage}`,
    })
  }
})

export const getFrHistory = createAsyncThunk(
  "getFrHistory",
  async (payload) => {
    try {
      const { data } = await ax.get("/api/admin/clients/freezeHistory", {
        params: payload,
      })
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  },
)

export const getPhoneChangesClub = createAsyncThunk(
  "getPhoneChangesClub",
  async (payload) => {
    try {
      const { data } = await ax.get(
        "/api/admin/directory/clubPhonesChangesHistory",
        {
          params: payload,
        },
      )
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  },
)

export const getPersonalPacket = createAsyncThunk(
  "getPersonalPacket",
  async (payload, { dispatch }) => {
    dispatch(setGetClientPersonalPacketListLoading(true))
    try {
      let data
      switch (payload.flag) {
        case "get":
          ;({ data } = await ax.get("/api/admin/clients/personalPacket", {
            params: payload.value,
          }))
          console.log("worked dispatch", data)
          data && dispatch(setGetClientPersonalPacketListLoading(false))
          return data
        case "put":
          ;({ data } = await ax.put(
            "/api/admin/clients/addPersonalPacket",
            payload.value,
          ))
          data &&
            openNotification({
              type: "success",
              message: `Пакет успешно отредактирован`,
            })
          break
        case "post":
          ;({ data } = await ax.post(
            "/api/admin/clients/editPersonalPacket",
            payload.value,
          ))
          data &&
            openNotification({
              type: "success",
              message: `Пакет успешно добавлен`,
            })
          break
        case "delete":
          ;({ data } = await ax.delete(
            "/api/admin/clients/deletePersonalPacket",
            { params: payload.value },
          ))
          data &&
            openNotification({
              type: "success",
              message: `Пакет успешно удален`,
            })
          break

        default:
          break
      }
    } catch (error) {
      dispatch(setGetClientPersonalPacketListLoading(false))
      openNotification({
        type: "error",
        message: `${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  },
)

export const getLink = createAsyncThunk(
  "getLink",
  async (payload, { dispatch }) => {
    dispatch(setGetClientLinkListLoading(true));
    try {
      let data;
      
      switch (payload.flag) {
        case "get":
          ({ data } = await ax.get("/api/admin/clients/clientLinks", {
            params: payload.value,
          }));
          data && dispatch(setGetClientLinkListLoading(false));
          return data;

        case "post":
          if (payload.method === "VTB(ТЕСТ)") {
            ({ data } = await ax.post("/api/recurrentVtb/createPayment", payload.value));
          } else if (payload.method === "CLOUDPAYMENT") {
            ({ data } = await ax.post("/api/recurrent/paymentLink", payload.value));
          } else if (payload.method === "Сертификат") { 
            ({ data } = await ax.post("/api/recurrent/certificateLink", payload.value));
          } else {
            throw new Error("Неизвестный метод оплаты");
          }
          
          if (data) {
            openNotification({
              type: "success",
              message: data.value?.name ?? `Ссылка успешно добавлена`,
            });
          }
          dispatch(setGetClientLinkListLoading(false));
          return data;

        default:
          dispatch(setGetClientLinkListLoading(false));
          return null;
      }
    } catch (error) {
      dispatch(setGetClientLinkListLoading(false));
      openNotification({
        type: "error",
        message: `Ошибка ${error.response?.data?.errorMessages?.[0]?.errorCode || "500"}. ${
          error.response?.data?.errorMessages?.[0]?.errorMessage || error.message || "Произошла ошибка"
        }`,
      });
      return error;
    }
  }
);

export const getPacketsList = createAsyncThunk(
  "getPacketsList",
  async (payload) => {
    try {
      const { data } = await ax.get("/api/admin/personalPackets", {
        params: payload,
      })
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  },
)

export const refundAction = createAsyncThunk(
  "refundAction",
  async (payload) => {
    try {
      const { data } = await ax.post(
        "/api/admin/clients/refundTransaction",
        payload.value,
      )
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  },
)

export const commentsAction = createAsyncThunk(
  "comment/commentsAction",
  async (payload, { dispatch }) => {
    dispatch(setCommentsListLoading(true))
    try {
      let data
      const url = "/api/admin/clients/comment"
      switch (payload.flag) {
        case "get":
          ;({ data } = await ax.get(url, { params: payload.value }))
          data && dispatch(setCommentsListLoading(false))
          return data

        case "post":
          ;({ data } = await ax.post(url, payload.value))
          data &&
            openNotification({
              type: "success",
              message: `Комментарий успешно отредактирован`,
            })
          break

        case "put":
          ;({ data } = await ax.put(url, payload.value))
          data &&
            openNotification({
              type: "success",
              message: `Комментарий успешно добавлен`,
            })
          break

        case "delete":
          ;({ data } = await ax.delete(url, { params: payload.value }))
          data &&
            openNotification({
              type: "success",
              message: `Комментарий успешно удален`,
            })
          break

        default:
          break
      }
    } catch (error) {
      dispatch(setCommentsListLoading(false))
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
      return error
    }
  },
)

// export const getClientsStatus = createAsyncThunk(
//   "clients/getClientStatus",
//   async (payload, {dispatch}) => {
//     try{
//       const {data} = await ax.get('/api/admin/clients/getClientStatuses', {
//         params: {userId: payload.value.UserId}
//       })
//       return data
//     }catch(error){
//       dispatch(setStatusListLoading(false));
//       openNotification({
//         type: "error",
//         message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`,
//       });
//       return error;
//     }
//   }
// )
export const getStatuses = createAsyncThunk(
  "status/getStatuses",
  async (_, { dispatch }) => {
    try {
      // dispatch(setStatusListLoading(true))
      const { data } = await ax.get("/api/admin/statusTypes")
      data
      console.log(data)
      return data
    } catch (error) {
      // dispatch(setStatusListLoading(false))

      openNotification({
        type: "error",
        message: `${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  },
)

export const addClientStatus = createAsyncThunk(
  "status/addClientStatus",
  async (payload, { dispatch }) => {
    try {
      // dispatch(setStatusListLoading(true))
      const { data } = await ax.post("/api/admin/clients/addClientStatus", {
        clientId: payload.clientId,
        statusId: payload.statusId,
      })
      data
      console.log(data)
      return data
    } catch (error) {
      // dispatch(setStatusListLoading(false))

      openNotification({
        type: "error",
        message: `${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  },
)

export const deletePhoneNumber = createAsyncThunk(
  "client/deletePhoneNumber",
  async (payload) => {
    try {
      const { data } = await ax.delete(
        "/api/admin/directory/deletePhoneBinding",
        {
          params: payload,
        },
      )
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  },
)

export const blockClient = createAsyncThunk(
  "client/blockClient",
  async (payload) => {
    try {
      const { data } = await ax.post("/api/admin/clients/blackList", payload)
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  },
)

export const changePassword = createAsyncThunk(
  "client/changePassword",
  async(payload) => {
    try{
      const {data} = await ax.post("/api/account/changePassword", payload)
      return data
    }catch(error) {
      openNotification({
        type: "error",
        message: `${error.response.data.errorMessages[0].errorMessage}`
      })
    }
  }
)

export const statusAction = createAsyncThunk(
  "status/getStatusAction",
  async (payload, { dispatch }) => {
    try {
      // dispatch(setStatusListLoading(true))
      const { data } = await ax.get("/api/admin/clients/getClientStatuses", {
        params: payload.value,
      })
      data
      console.log(data)
      return data
    } catch (error) {
      // dispatch(setStatusListLoading(false))

      openNotification({
        type: "error",
        message: `${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
    // console.log('payload')

    // try {
    //   let data
    //   const url = "/api/admin/clients/getClientStatuses"
    //   switch (payload.flag) {
    //     case "get":
    //       ;({ data } = await ax.get(url, { params: payload.value }))
    //       console.log('datastatusAction', statusAction)
    //       data && dispatch(setStatusListLoading(false))
    //       console.log('data',data)
    //       return data

    //     case "post":
    //       ({ data } = await ax.post(url, payload.value))
    //       data &&
    //         openNotification({
    //           type: "success",
    //           message: `Статус успешно добавлен`,
    //         })
    //       break

    //     case "put":
    //       ({ data } = await ax.put(url, payload.value))
    //       if (data) {
    //         openNotification({
    //           type: "success",
    //           message: `Статус успешно отредактирован`,
    //         })
    //         dispatch(
    //           statusAction({
    //             flag: "get",
    //             value: { userId: payload.value?.userId },
    //           })
    //         )
    //       }
    //       break

    //     case "delete":
    //       ;({ data } = await ax.delete(url, { params: payload.value }))
    //       data &&
    //         openNotification({
    //           type: "success",
    //           message: `Статус успешно удален`,
    //         })
    //       break

    //     default:
    //       break
    //   }
    // } catch (error) {
    //   openNotification({
    //     type: "error",
    //     message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`,
    //   })
    //   return error
    // }
  },
)

const ClientsSlice = createSlice({
  name: "clients",
  initialState,
  reducers: {
    setClientsListLoading: (state, action) => {
      state.clientsListLoading = action.payload
    },
    setAddClientModal: (state, action) => {
      state.addClientModal = action.payload
    },
    setAddAbonementModal: (state, action) => {
      state.addAbonementModal = action.payload
    },
    setGetAbonementsClientListLoading: (state, action) => {
      state.getAbonementsClientListLoading = action.payload
    },
    setGetClientTrainingsListLoading: (state, action) => {
      state.getClientTrainingsListLoading = action.payload
    },
    setClientLeadedTrainingsLoading: (state, action) => {
      state.clientLeadedTrainingsLoading = action.payload
    },
    setGetClientTransactionsListLoading: (state, action) => {
      state.getClientTransactionsListLoading = action.payload
    },
    setGetClientLinkListLoading: (state, action) => {
      state.getClientLinkListLoading = action.payload
    },

    setCommentsListLoading: (state, action) => {
      state.commentsListLoading = action.payload
    },
    setGetClientPersonalPacketListLoading: (state, action) => {
      state.getClientPersonalPacketListLoading = action.payload
    },
    setStatusListLoading: (state, action) => {
      state.getClientStatusLoading = action.payload
    },
    setGetClientStatusList: (state, action) => {
      state.getClientStatusList = action.payload
    },
  },
  extraReducers: (builder) => {
    ;(builder.addCase(getClientsList.fulfilled, (state, action) => {
      state.clientsList = action.payload
    }),
      builder.addCase(getAbonementsList.fulfilled, (state, action) => {
        state.abonementsList = action.payload
      }),
      builder.addCase(getAbonementsClient.fulfilled, (state, action) => {
        state.getAbonementsClientList = action.payload
      }),
      builder.addCase(getClientTrainings.fulfilled, (state, action) => {
        state.getClientTrainingsList = action.payload
      }),
      builder.addCase(getClientLeadedTrainings.fulfilled, (state, action) => {
        state.clientLeadedTrainings = action.payload
      }),
      builder.addCase(getTransactions.fulfilled, (state, action) => {
        state.getClientTransactionsList = action.payload
      }),
      builder.addCase(getLink.fulfilled, (state, action) => {
        state.getClientLinkList = action.payload
      }),
      builder.addCase(getReport.fulfilled, (state, action) => {
        state.reportData = action.payload
      }),
      builder.addCase(getClubs.fulfilled, (state, action) => {
        state.clubs = action.payload
      }),
      builder.addCase(getAbonements.fulfilled, (state, action) => {
        state.abonements = action.payload
      }),
      builder.addCase(getUserInfo.fulfilled, (state, action) => {
        state.userInfo = action.payload
      }),
      builder.addCase(commentsAction.fulfilled, (state, action) => {
        state.commentsList = action.payload
      }),
      builder.addCase(getCode.fulfilled, (state, action) => {
        state.code = action.payload
      }),
      builder.addCase(getPacketsList.fulfilled, (state, action) => {
        state.packetsList = action.payload
      }),
      builder.addCase(getPersonalPacket.fulfilled, (state, action) => {
        state.getClientPersonalPacketList = action.payload
      }),
      builder.addCase(statusAction.pending, (state) => {
        state.getClientStatusListLoading = true
        console.log("dssfsfsffs")
      }),
      builder.addCase(statusAction.fulfilled, (state, action) => {
        state.getClientStatusListLoading = false
        // if (action.meta.arg.flag === "get") {
        state.getClientStatusList = action.payload
        // }
      }),
      builder.addCase(statusAction.rejected, (state, payload) => {
        // console.log('dssfsfsffs')
        state.getClientStatusListLoading = false
      }))

    ;(builder.addCase(getStatuses.pending, (state) => {
      state.getStatusesLoading = true
    }),
      builder.addCase(getStatuses.fulfilled, (state, action) => {
        state.getStatusesLoading = false
        console.log("dssfsfsffs")
        state.getStatuses = action.payload.data.value
      }),
      builder.addCase(getStatuses.rejected, (state, payload) => {
        // console.log('dssfsfsffs')
        console.log("payload", payload)
        state.getStatusesLoading = false
      })),
      builder.addCase(blockClient.pending, (state) => {
        state.blockClientLoading = true
      }),
      builder.addCase(blockClient.fulfilled, (state, action) => {
        state.blockClientLoading = false
        state.blockClient = action.payload
        console.log("blockClient.fulfilled payload:", action.payload)
      }),
      builder.addCase(blockClient.rejected, (state) => {
        state.blockClientLoading = false
      }),
      builder.addCase(changePassword.pending, (state) => {
        state.changePasswordLoading = true
      }),
      builder.addCase(changePassword.fulfilled, (state, action) => {
        state.changePasswordLoading = false
        state.changePassword = action.payload
      }),
      builder.addCase(changePassword.rejected, (state) => {
        state.changePasswordLoading = false
      })
  },
})

export const {
  setClientsListLoading,
  setAddClientModal,
  setAddAbonementModal,
  setGetAbonementsClientListLoading,
  setGetClientTrainingsListLoading,
  setClientLeadedTrainingsLoading,
  setGetClientTransactionsListLoading,
  setGetClientLinkListLoading,
  setCommentsListLoading,
  setGetClientPersonalPacketListLoading,
  setGetClientStatusList,
} = ClientsSlice.actions

export default ClientsSlice.reducer
